export function isAppleDevice() {
	return /Macintosh|iPad|iPhone|iPod/.test(navigator.userAgent)
}
